import { SpyneTrait, ChannelPayloadFilter } from 'spyne';

// Keyboard vocabulary for the show. Every key maps to a step or an edge;
// the channel clamps at the ends — no wrap-around.
const keySteps = {
  ArrowDown: 1,
  ArrowRight: 1,
  PageDown: 1,
  ' ': 1,
  ArrowUp: -1,
  ArrowLeft: -1,
  PageUp: -1,
};
const keyEdges = { Home: 'first', End: 'last' };

export class ChannelSlideshowTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = 'channelSlideshow$';
    super(context, traitPrefix);
  }

  static channelSlideshow$OnRegistered() {
    const fullscreenFilter = new ChannelPayloadFilter({
      action: 'CHANNEL_FULLSCREEN_CHANGE_EVENT',
    });
    const keyFilter = new ChannelPayloadFilter({
      action: 'CHANNEL_WINDOW_KEYUP_EVENT',
    });

    this.getChannel('CHANNEL_FULLSCREEN', fullscreenFilter).subscribe(
      this.channelSlideshow$OnFullscreenChange.bind(this),
    );
    this.getChannel('CHANNEL_WINDOW', keyFilter).subscribe(
      this.channelSlideshow$OnKeyup.bind(this),
    );
  }

  // The show follows the browser-confirmed fullscreen state, so Esc and a
  // refused request both land here.
  static channelSlideshow$OnFullscreenChange(e) {
    const isFullscreen = e.payload?.isFullscreen === true;

    if (isFullscreen === this.props.isActive) {
      return;
    }
    this.props.isActive = isFullscreen;

    const action = isFullscreen
      ? 'CHANNEL_SLIDESHOW_ACTIVATED_EVENT'
      : 'CHANNEL_SLIDESHOW_DEACTIVATED_EVENT';

    this.sendChannelPayload(action, { slideNum: this.props.currentSlideNum });
  }

  // The container answers ACTIVATED with the slide in the viewport and the
  // last index; that report starts the show.
  static channelSlideshow$OnViewportReport(e) {
    const { slideNum, maxSlideNum } = e.payload;

    if (Number.isInteger(maxSlideNum) === true) {
      this.props.maxSlideNum = maxSlideNum;
    }
    this.channelSlideshow$DisplaySlide(slideNum);
  }

  static channelSlideshow$OnKeyup(e) {
    if (this.props.isActive !== true) {
      return;
    }

    const key = e.payload?.key;
    const { currentSlideNum, maxSlideNum } = this.props;

    if (keyEdges[key] !== undefined) {
      this.channelSlideshow$DisplaySlide(keyEdges[key] === 'first' ? 0 : maxSlideNum);
    } else if (keySteps[key] !== undefined) {
      this.channelSlideshow$DisplaySlide(currentSlideNum + keySteps[key]);
    }
  }

  static channelSlideshow$DisplaySlide(requestedNum) {
    const { maxSlideNum } = this.props;
    const slideNum = Math.min(Math.max(Number(requestedNum) || 0, 0), maxSlideNum);

    this.props.currentSlideNum = slideNum;
    this.sendChannelPayload('CHANNEL_SLIDESHOW_DISPLAY_SLIDE_EVENT', { slideNum });
  }
}
